import {
  captchaPlaceholder,
  urlPlaceholder,
} from 'common/constants/management-store-placeholders'
import { ManagementState } from 'publisher/store/management/managementStateInterface'

function isScreenshotMode(state: ManagementState) {
  return state.screenshotMode
}

function getFunnelStepId(state: ManagementState) {
  return state.funnelStepId
}

function getUrl(state: ManagementState) {
  if (typeof window !== 'undefined' && state.url === urlPlaceholder) {
    return ''
  }

  return state.url || window.location.href
}

function isDesktop(state: ManagementState) {
  return !state.isMobile
}

function isMobile(state: ManagementState) {
  return state.isMobile
}

function isPreview(state: ManagementState) {
  return state.previewMode === true
}

function getConfirmedCheckboxesIds(state: ManagementState) {
  return state.confirmedExplicitConsents
}

function getCaptcha(state: ManagementState) {
  return state.captcha === captchaPlaceholder ? null : state.captcha
}

function getActivePopupId(state: ManagementState) {
  return state.activePopupId
}

const managementSelectors = {
  isScreenshotMode,
  getFunnelStepId,
  isDesktop,
  isMobile,
  getUrl,
  isPreview,
  getConfirmedCheckboxesIds,
  getCaptcha,
  getActivePopupId,
}

export default managementSelectors
